import { openModal } from '@mantine/modals';
import { Text, ThemeIcon, Stack, Button } from '@mantine/core';
import { IconCrown, IconMail } from '@tabler/icons-react';
import { t } from 'i18next';

export function openPayingCustomersModal() {
    openModal({
        title: t('premium_feature_title'),
        centered: true,
        radius: 'md',
        size: 'sm',
        children: (
            <Stack align="center" gap="md" py="md">
                <ThemeIcon size={64} radius="xl" color="yellow" variant="light">
                    <IconCrown size={36} stroke={1.5} />
                </ThemeIcon>
                <div className="text-center space-y-2">
                    <Text size="lg" className="font-extrabold text-slate-800">
                        {t('paying_customers_only_heading')}
                    </Text>
                    <Text size="sm" className="text-slate-600 font-medium leading-relaxed">
                        {t('paying_customers_only_description')}
                    </Text>
                </div>
                <Button
                    component="a"
                    href="mailto:hola@turizi.com?subject=Upgrade%20to%20Paying%20Customer"
                    color="black"
                    radius="xl"
                    leftSection={<IconMail size={16} />}
                    className="font-bold w-full"
                >
                    hola@turizi.com
                </Button>
            </Stack>
        )
    });
}
